document.querySelectorAll('.js--accordion-trigger').forEach(header => {
    header.addEventListener('click', () => {
        const item = header.closest('.js--accordion');
        if (!item) return;

        const content = item.querySelector('.js--accordion-content');
        if (!content) return;

        const isExpanded = header.getAttribute('aria-expanded') === 'true';

        // 状態の反転
        header.setAttribute('aria-expanded', String(!isExpanded));
        content.setAttribute('aria-hidden', String(isExpanded));
        item.classList.toggle('is-active');
    });
});


/* フォーマット例

<div class="accordion js--accordion">
    <button class="accordion__trigger js--accordion-trigger" aria-expanded="false" aria-controls="content-1">タイトル</button>
    <div id="content-1" class="accordion__content js--accordion-content" aria-hidden="true">
        <div class="accordion__inner">
            コンテンツ
        </div>
    </div>
</div>

*/
